import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { LanguageService } from 'src/app/shared/services/language.service';
import { Language } from 'src/app/shared/models/classes/language';
import { UiService } from 'src/app/shared/services/ui.service';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
    languageForm: FormGroup;
    languageList: Language[];
    isLoading: boolean;

    constructor(
        private fb: FormBuilder,
        private langSrv: LanguageService,
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.isLoading = true;

        this.langSrv.getList()
        .subscribe(languages => {
            this.languageList = languages;
            this.initForm();
            this.isLoading = false;
        });

        this.langSrv.languageChanged
        .subscribe(() => {
            this.initForm();
        });
    }

    private initForm(): void {
        const currentLang = this.langSrv.getCurrentLanguageCode();
        let lang = this.languageList.find(l => l.codeISO === currentLang);

        if(!lang) {
            lang = this.languageList[0];
        }

        this.languageForm = this.fb.group({
            lang: [lang]
        });

        this.languageForm.controls.lang.valueChanges
        .subscribe((selected: Language) => {
            this.uiSrv.translationLoadingStateChanged.next(true);
            this.langSrv.setCurrentLanguage(selected.codeISO)
            .subscribe(() => {
                this.uiSrv.translationLoadingStateChanged.next(false);
            });
        });
    }
}
